<template>
    <div>
        <div id="editor"></div>

        <q-dialog v-model="image_picker" :maximized="$q.platform.is.mobile" @hide="hideImagePickerModal()">
            <q-card :style="!$q.platform.is.mobile ? 'max-height: 80vh; height: 60vh; width: 60vw;' : ''">
                <q-toolbar>
                    <q-toolbar-title>{{ $t('add_image') }}</q-toolbar-title>

                    <q-btn flat round dense icon="fal fa-times" v-close-popup />
                </q-toolbar>

                <q-separator />

                <q-card-section>
                    <q-tabs stretch v-model="tab">
                        <q-tab name="device" :label="$t('image_from_device')" />
                        <q-tab name="web" :label="$t('image_from_url')" />
                    </q-tabs>

                    <q-tab-panels v-model="tab" animated>
                        <q-tab-panel name="device">
                            <div class="row">
                                <div class="col-12">
                                    <uploader :custom_directory="customDirectory" @fileUploaded="fileUploaded" @uploadStarted="uploadStarted" content_type="images" />
                                </div>
                            </div>
                        </q-tab-panel>

                        <q-tab-panel name="web">
                            <div class="row q-col-gutter-md">
                                <div class="col-12">
                                    <q-input v-model="image_link" :label="$t('image_url')" />
                                </div>

                                <div class="col-12 text-right">
                                    <q-btn color="negative" :label="$t('cancel')" v-close-popup class="q-mr-sm" />
                                    <q-btn color="positive" :label="$t('save')" @click="insertImage()" />
                                </div>
                            </div>
                        </q-tab-panel>
                    </q-tab-panels>
                </q-card-section>
            </q-card>
        </q-dialog>
    </div>
</template>

<script>


import Editor from '@toast-ui/editor'
import '@toast-ui/editor/dist/toastui-editor.css'
import * as moment from 'moment'
import Uploader from 'components/utils/Uploader'

export default {
    props: ['editorText', 'id', 'initialText', 'imagePath'],

    data() {
        return {
            added_custom_button: false,
            image_picker: false,
            tab: 'device',
            image_link: '',
            image_file: null,
            text_with_image_link: '',
            file_url: '',
            options: {
                minHeight: '300px',
                language: 'en_US',
                useCommandShortcut: true,
                useDefaultHTMLSanitizer: true,
                usageStatistics: false,
                hideModeSwitch: true,
                mode: 'wysiwyg',
                toolbarItems: [
                    'heading',
                    'bold',
                    'italic',
                    'strike',
                    'divider',
                    'ul',
                    'ol',
                    'task',
                    'indent',
                    'outdent',
                    'divider',
                    'link',
                ]
            },
            editor: null
        }
    },

    components: {
        'uploader': Uploader
    },

    computed: {
        customDirectory() {
            let date = moment()
            return `${this.imagePath}/${date.year()}/${date.month() + 1}/`
        },

        getToolbarItems() {
            if(this.$q.platform.is.mobile) {
                return [
                    ['heading', 'bold', 'italic', 'strike', 'ul', 'ol'],
                    [{
                        el: this.createLastButton(),
                        command: 'create',
                        tooltip: this.$t('add_image')
                    }]
                ]
            }
            else {
                return [
                    ['heading', 'bold', 'italic', 'strike'],
                    ['ul', 'ol', 'task', 'indent', 'outdent'],
                    [{
                        el: this.createLastButton(),
                        command: 'create',
                        tooltip: this.$t('add_image')
                    }]
                ]
            }
        },
        

    },

    methods: {
        onEditorChange() {
            this.$emit('setMessage', this.editor.getMarkdown())
        },

        openImagePicker() {
            this.image_picker = true
        },

        insertImage() {
            this.image_picker = false

            if (this.tab === 'web') {
                if (this.image_link) {
                    this.text_with_image_link = this.editorText + `\n![${'teste1'}](${this.image_link} "${'teste2'}")\n`
                    this.$emit('setMessageWithImage', this.text_with_image_link)
                    this.createdEditor(this.text_with_image_link)
                    
                }
                else this.image_picker = false
            }
            else if (this.tab === 'device') {
                if (this.image_file) {
                    this.$emit('file-chosen', this.image_file)
                }
                else this.image_picker = false
            }
        },

        uploadStarted() {
            this.$q.loading.show()
        },

        fileUploaded(url) {
            let data = {
                file_url: url
            }

            this.$axios.post('/utils/presigned_url/', data)
            .then(response => {
                this.file_url = response.data.file_url
                this.text_with_image_link = this.editorText + `\n![${this.image_file_description}](${response.data.file_url} "${this.image_file_description}")\n`
                this.$emit('setMessageWithImage', this.text_with_image_link)
                this.createdEditor(this.text_with_image_link)

            })
            .catch(e => {
                console.log(e)
            })
            .finally(() => {
                this.image_picker = false
                this.$q.loading.hide()
            })
        },

        hideImagePickerModal() {
            this.image_file = null
            this.image_link = ''
            this.image_description = ''
        },
        
        createLastButton() {
            const button = document.createElement('button');
            button.className = 'fas fa-image-polaroid fa-xl';
            button.style.backgroundImage = 'none';
            button.style.margin = '0';
            button.style.fontSize = '19px'
            button.style.color = '#a2a2a2'
            button.style.backgroundColor='#f7f9fc'

            button.addEventListener('click', this.openImagePicker )
            return button;
        },

        createdEditor(val) {
            // Não remover o espaço em branco na estring do ternario initialValue
            this.editor = new Editor({
            el: document.querySelector('#editor'),
            initialEditType: 'wysiwyg',
            initialValue: val ? val : ' ',
            toolbarItems: this.getToolbarItems,
            events: {
                change: this.onEditorChange,
            },
        })
        }
    },

    mounted() {
        this.createdEditor()
    },

    beforeDestroy () {
        this.added_custom_button = false
        this.editor = null
    }
}
</script>

<style lang="scss" scoped>
.file-picker {
	&:hover {
		cursor: pointer;
	}
}
</style>
